import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {setLanguage} from "../redux/actions";
import {IconChevronDown} from "@tabler/icons-react";
import {Select} from "@mantine/core";
import React from "react";


export default function LanguageSelect({isMobile}){
    const languages = ["English", "Español", "Français"]
    const currentLanguage = useSelector(state => state.language.currentLanguage);
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();

    const handleSetLanguage= (language) => {
        localStorage.setItem("currentLanguage", language); //uncomment if want local storage to be consistent, otherwise will default to first customer
        dispatch(setLanguage(language))
        i18n.changeLanguage(language);
    }
    return (
        <>
        {
            isMobile ? (
                    <Select
                        placeholder="Pick value"
                        value={currentLanguage}
                        allowDeselect={false}
                        onChange={handleSetLanguage}
                        rightSection={<IconChevronDown/>}
                        data={languages}/>)

                : (<Select
                    mt="3"
                    styles={{wrapper: {width: 110}}}
                    placeholder="Pick value"
                    value={currentLanguage}
                    allowDeselect={false}
                    onChange={handleSetLanguage}
                    rightSection={<IconChevronDown/>}
                    data={languages}/>)
        }
        </>
    )
}